'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _components = require('components');

var _Link = require('react-router/lib/Link');

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectReportPlayedUsers = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ProjectReportPlayedUsers, _Component);

  function ProjectReportPlayedUsers() {
    (0, _classCallCheck3.default)(this, ProjectReportPlayedUsers);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectReportPlayedUsers.__proto__ || (0, _getPrototypeOf2.default)(ProjectReportPlayedUsers)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectReportPlayedUsers, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          reportData = _props.reportData;
      var _reportData$viewers = reportData.viewers,
          viewers = _reportData$viewers === undefined ? [] : _reportData$viewers,
          _reportData$project = reportData.project,
          project = _reportData$project === undefined ? {} : _reportData$project,
          _reportData$downloade = reportData.downloadedViewers,
          downloadedViewers = _reportData$downloade === undefined ? {} : _reportData$downloade;


      if (!viewers.length) {
        return _react2.default.createElement(_components.NoRecords, null);
      }

      return _react2.default.createElement(
        _components.List,
        null,
        _react2.default.createElement(
          _components.ListItem,
          { fullWidth: true, isTitle: true },
          _react2.default.createElement(
            'div',
            null,
            'ID'
          ),
          _react2.default.createElement(
            'div',
            null,
            'IP'
          ),
          _react2.default.createElement(
            'div',
            null,
            t('Name')
          ),
          _react2.default.createElement(
            'div',
            null,
            t('Downloaded')
          ),
          _react2.default.createElement('div', null)
        ),
        viewers.map(function (recipient) {
          return _react2.default.createElement(
            _components.ListItem,
            { key: recipient.recipientId, fullWidth: true },
            _react2.default.createElement(
              'div',
              null,
              recipient.recipientId
            ),
            _react2.default.createElement(
              'div',
              null,
              recipient.ip
            ),
            _react2.default.createElement(
              'div',
              null,
              recipient.fullName
            ),
            _react2.default.createElement(
              'div',
              null,
              downloadedViewers[recipient.recipientId] ? t('Yes') : t('No')
            ),
            _react2.default.createElement(
              _Link2.default,
              { to: '/projects/' + project.projectContentType + '/' + project.projectId + '/report/' + recipient.recipientId },
              t('details')
            )
          );
        })
      );
    }
  }]);
  return ProjectReportPlayedUsers;
}(_react.Component), _class2.propTypes = {
  reportData: _propTypes2.default.object,
  t: _propTypes2.default.func
}, _temp)) || _class);
exports.default = ProjectReportPlayedUsers;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectReport/ProjectReportPlayedUsers.js
// module id = 2056
// module chunks = 1